.dropdown {
  > div:last-child {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }

  div[type="button"] {
    text-align: center;
  }
}
